export const ThoughtsScroll = (elem: HTMLElement): void => {
  let isDrag = false;
  const dragStart = (): void => {
    isDrag = true;
  };
  const dragEnd = (): void => {
    isDrag = false;
  };
  const drag = (ev: PointerEvent): void => {
    if (isDrag) {
      elem.scrollLeft -= ev.movementX;
      setTimeout(() => {
        if (elem.scrollWidth - elem.scrollLeft <= elem.clientWidth) {
          elem.classList.add('hide-after');
        } else {
          elem.classList.remove('hide-after');
        }
      }, 20);
    }
  };

  elem.addEventListener('pointerdown', dragStart);
  window.addEventListener('pointerup', dragEnd);
  window.addEventListener('pointermove', drag);
};

const slider = document.querySelector('.list-article-author-total-2') as HTMLElement;
if (slider) {
  ThoughtsScroll(slider);
}

export default ThoughtsScroll;
